import { render, staticRenderFns } from "./EditProgress.vue?vue&type=template&id=4ed2b4bd&scoped=true&"
import script from "./EditProgress.vue?vue&type=script&lang=js&"
export * from "./EditProgress.vue?vue&type=script&lang=js&"
import style0 from "./EditProgress.vue?vue&type=style&index=0&id=4ed2b4bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed2b4bd",
  null
  
)

export default component.exports